import React from 'react'
import { useMemo, useState } from 'react'
import { createContext, useContextSelector } from 'use-context-selector'

import { NOOP } from 'constants/commonConstans'

interface IGroupingFormValueContext {
  form?: 'root' | 'image' | 'answer'
  groupIndex?: number
  groupName?: string
  answerIndex?: number
  answerName?: string
  setContext: React.Dispatch<React.SetStateAction<Omit<IGroupingFormValueContext, 'setContext'>>>
}

const DEFAULT_CONTEXT: Omit<IGroupingFormValueContext, 'setContext'> = {
  form: 'root',
  groupName: '',
  groupIndex: 0,
  answerName: '',
  answerIndex: 0,
}

const GroupingFormValueContext = createContext<IGroupingFormValueContext>({
  ...DEFAULT_CONTEXT,
  setContext: NOOP,
})

interface IGroupingFormValueProviderProps {
  children: React.ReactNode
}

const GroupingFormValueProvider: React.FC<IGroupingFormValueProviderProps> = ({ children }) => {
  const [value, setValue] = useState<Partial<IGroupingFormValueContext>>(DEFAULT_CONTEXT)
  const context = useMemo(() => ({ ...value, setContext: setValue }), [value])

  return (
    <GroupingFormValueContext.Provider value={context}>
      {children}
    </GroupingFormValueContext.Provider>
  )
}

export const useGroupingFormValueContext = () => {
  return useContextSelector(GroupingFormValueContext, (c) => c)
}

export const useGroupingFormValueUpdateForm = () => {
  return useContextSelector(GroupingFormValueContext, (c) => c.setContext)
}

export default React.memo(GroupingFormValueProvider) as typeof GroupingFormValueProvider
